var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrendingUp24PxCommandcenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "trending_up-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.973,
    height: 16.973,
    viewBox: "0 0 16.973 16.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13929",
    "data-name": "Path 13929",
    d: "M0,0H16.973V16.973H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13930",
    "data-name": "Path 13930",
    d: "M11.9,6l1.62,1.62-3.451,3.451L7.24,8.242,2,13.489l1,1L7.24,10.243l2.829,2.829,4.455-4.448,1.62,1.62V6Z",
    transform: "translate(-0.586 -1.757)",
    fill: "#6a8eff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingUp24PxCommandcenter);
export default __webpack_public_path__ + "static/media/trending_up-24px_commandcenter.e668dc491b3af7a4d0a75609e0f88131.svg";
export { ForwardRef as ReactComponent };